/**
 * ai-sources-page.tsx — Nhân viên AI › "Nguồn AI và lượt AI" (`/ai/nguon`; xem: `ai.view`, sửa: `ai.update`).
 * Tầng TỔ CHỨC của khung ba tầng: ví credit + mua thêm, Tạm dừng toàn bộ AI, CHỌN NGUỒN AI TRƯỚC rồi mới xổ model
 * (source-mode-card.tsx: AI của eCDP / Key của tôi + key, model tuỳ chỉnh), giới hạn theo nguồn đang dùng, nhúng tài liệu
 * vượt trần, AI hỗ trợ nhân viên. Không ô nào ở đây đổi cách nhân viên AI
 * trả lời khách (các cài đặt đó nằm ở từng nhân viên AI). Link sang màn khác (Theo dõi, Nhân viên AI) mở ở tab mới.
 */
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/shared/page-header'
import { Loading, ErrorState } from '@/components/shared/feedback'
import { useAiConfig } from '@/hooks/use-ai'
import { useAiCredits, useAiCreditsSocket, useAiModels, useAiSources } from '@/hooks/use-ai-credits'
import { AI_PATHS } from '@/lib/ai-khung'
import { AiCreditBanner, AiCreditChip, WalletStrip } from './credits/credit-widgets'
import { BuyCreditsDialog } from './credits/buy-credits-dialog'
import { EmbeddingCard } from './credits/source-panels'
import { SourceModeSection } from './sources/source-mode-card'
import { orgSourceMode } from './sources/source-mode-lib'
import { LimitsCard, MovedToBotsNote, PauseAllCard, StaffAssistCard } from './sources/org-ai-cards'
import { useAiPerms } from './use-ai-perms'

export function AiSourcesPage() {
  const { t } = useTranslation('aiOps')
  // Đổi nguồn / model / key / giới hạn / tạm dừng AI: ai-sources-routes, ai-routes, ai-credit-routes đòi `ai.update`.
  // Không có quyền → chỉ xem (ẩn nút, ô nhập khoá).
  const { canEdit } = useAiPerms()
  const [buyOpen, setBuyOpen] = useState(false)
  const { data: config, isLoading, isError } = useAiConfig()
  const { data: credits } = useAiCredits()
  const { data: modelsData } = useAiModels()
  const { data: sources } = useAiSources()
  const mode = orgSourceMode(sources?.providers)
  useAiCreditsSocket()

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('sourcesPage.title')}
        description={t('sourcesPage.description')}
        actions={credits ? <AiCreditChip credits={credits} onBuy={() => setBuyOpen(true)} /> : undefined}
      />
      <BuyCreditsDialog open={buyOpen} onOpenChange={setBuyOpen} />
      {credits && <AiCreditBanner credits={credits} onBuy={() => setBuyOpen(true)} />}

      {isLoading ? (
        <Loading label={t('sourcesPage.loading')} />
      ) : isError || !config ? (
        <ErrorState message={t('sourcesPage.loadError')} />
      ) : (
        <>
          <PauseAllCard config={config} canEdit={canEdit} />
          {credits && (
            <WalletStrip
              credits={credits}
              planName={modelsData?.plan?.name}
              onBuy={() => setBuyOpen(true)}
              historyHref={`${AI_PATHS.tracking}#thong-ke`}
            />
          )}
          <SourceModeSection config={config} canEdit={canEdit} onBuy={() => setBuyOpen(true)} />
          <MovedToBotsNote />
          <LimitsCard config={config} canEdit={canEdit} mode={mode} />
          {credits?.embedding && <EmbeddingCard credits={credits} canEdit={canEdit} planName={modelsData?.plan?.name} />}
          <StaffAssistCard config={config} canEdit={canEdit} />
        </>
      )}
    </div>
  )
}
